import { LAST_SHOWN_USAGE_ALERT_LIMIT } from 'frontend/core/src/utils/localstorage-keys';

export const getUsageAlertFromStorage = (teamId: string, userId: string) => {
  try {
    const data = JSON.parse(localStorage.getItem(LAST_SHOWN_USAGE_ALERT_LIMIT) || '{}');

    return data[`teamId_${teamId}_userId_${userId}`];
  } catch (error) {
    return null;
  }
};

export const setUsageAlertToStorage = (teamId: string, userId: string, alertAmount: number) => {
  const data = JSON.parse(localStorage.getItem(LAST_SHOWN_USAGE_ALERT_LIMIT) || '{}');
  data[`teamId_${teamId}_userId_${userId}`] = alertAmount;
  localStorage.setItem(LAST_SHOWN_USAGE_ALERT_LIMIT, JSON.stringify(data));
};
